import { render } from "./ProjectAdvertBannerCountdown.vue?vue&type=template&id=cd5f545c"
import script from "./ProjectAdvertBannerCountdown.vue?vue&type=script&lang=js"
export * from "./ProjectAdvertBannerCountdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__